import { formatValue } from '../../../utils/managerUtils';
import { DatasetItem } from '../../../types/types';

const TEMPORAL_TYPES = ['date', 'dateTime', 'time'];

export const getControlLabelValue = (
  row: Record<string, unknown>,
  labelColumn: DatasetItem | undefined,
  labelColumnName: string
): string => {
  if (labelColumn && TEMPORAL_TYPES.includes(labelColumn.type ?? '')) {
    return String(formatValue(row, labelColumn));
  }
  return row[labelColumnName] as string;
};
